import * as yup from 'yup';
import { password, verifyPassword } from './baseSchema';

const ForgotPasswordSchema = yup.object().shape({
  password,
  verifyPassword,
});

export default ForgotPasswordSchema;
